import { render, staticRenderFns } from "./TrainingExamsTab.vue?vue&type=template&id=7c1c8afe&scoped=true&lang=pug"
import script from "./TrainingExamsTab.vue?vue&type=script&lang=js"
export * from "./TrainingExamsTab.vue?vue&type=script&lang=js"
import style0 from "./TrainingExamsTab.vue?vue&type=style&index=0&id=7c1c8afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c8afe",
  null
  
)

export default component.exports